const uischema = (schema) => ({
  type: "VerticalLayout",
  elements: [
    {
      type: "HorizontalLayout",
      elements: [
        {
          type: "Control",
          label: "Tenant",
          scope: "#/properties/tenantId",
        },
        {
          type: "Control",
          label: "Tenant Role",
          scope: "#/properties/tenantUserRoleId",
        },
        ...(schema.properties?.expiresAt
          ? [
            {
              type: "Control",
              label: "Expires At",
              scope: "#/properties/expiresAt",
              options: {
                format: "date",
                disablePast: true,
                disablePresent: true,
              },
            },
          ]
          : []),
      ],
    },
  ],
});

export default uischema;
